import React, { Component } from 'react';

export default class Modal extends Component {
	constructor(props) {
		super(props);

		this.state = {
			name: this.props.modal && this.props.modal.name ? this.props.modal.name : '',
			toSetId: this.props.selectedSet
		}

		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		this.setState(state => {
			state.name = nextProps.modal && nextProps.modal.name ? nextProps.modal.name : '';
			state.toSetId = nextProps.selectedSet;
			return state;
		});
	}

	handleInputChange(event) {
		this.setState({ toSetId: event.target.value });
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.handleMoveTally(
			'MOVE', {
				tallyId: this.props.selectedTally,
				fromSetId: this.props.selectedSet,
				toSetId: this.state.toSetId
			}
		);
	}

	render() {
		return (
			<div className="MODAL">
				<form onSubmit={this.handleSubmit}>
					<div className="text">Move <b>{this.state.name}</b> to the following set:</div>
					<div className="select">
						<select name="set" onChange={this.handleInputChange} value={this.state.toSetId}>
							{this.props.sets && this.props.sets.map(set => (
								<option key={set.id} value={set.id}>{set.name}</option>
							))}
						</select>
					</div>
					<button className="button alt-confirm" type="submit">Move</button>
					<label htmlFor="modal-toggle" className="button alt-cancel">Cancel</label>
				</form>
			</div>
		);
	}
};


// WEBPACK FOOTER //
// ./src/modals/move-tally.js